// src/hooks/WalletSyncNotifier.js
import { useEffect, useContext, useRef } from "react";
import { rawAPICall } from "src/Apiconfig/service";
import ApiConfig from "src/Apiconfig/config";
import { AuthContext } from "src/context/Auth";
import { useSnackbar } from "src/context/SnackbarProvider";

export const useWalletSyncNotifier = () => {
    const { userData, userAddedWallets } = useContext(AuthContext);
    const { showSnackbar } = useSnackbar();
    const previousStatusesRef = useRef({});

    useEffect(() => {
        if (!userData?.uid) return;

        const pollStatuses = async () => {
            try {
                const response = await rawAPICall({
                    method: "GET",
                    url: `${ApiConfig["load"]}/status`,
                });
                const walletStatuses = response.data?.walletStatuses || [];

                walletStatuses.forEach(wallet => {
                    const walletId = wallet.walletId;
                    const prevStatus = previousStatusesRef.current[walletId];
                    const currStatus = wallet.status;

                    if (
                        (prevStatus === "IN_PROGRESS" || prevStatus === "PUBLISHED") &&
                        currStatus === "COMPLETED_SUCCESSFULLY"
                    ) {
                        const walletInfo = userAddedWallets?.find(w => w.walletId === walletId);
                        const walletName = walletInfo?.name || "Your";
                        showSnackbar(`${walletName} wallet synced successfully!`);
                    }

                    previousStatusesRef.current[walletId] = currStatus;
                });
            } catch (e) {
                console.error("Wallet sync polling failed:", e);
            }
        };

        pollStatuses();
        const intervalId = setInterval(pollStatuses, 60000);
        return () => clearInterval(intervalId);
    }, [userData?.uid, userAddedWallets]);
};
